import { useEffect } from 'react';

const SiteProtection = () => {
  useEffect(() => {
    // --- Disable right-click context menu ---
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // --- Block DevTools keyboard shortcuts ---
    const handleKeyDown = (e) => {
      // F12
      if (e.key === 'F12') { e.preventDefault(); return false; }
      // Ctrl+Shift+I (DevTools)
      if (e.ctrlKey && e.shiftKey && e.key === 'I') { e.preventDefault(); return false; }
      // Ctrl+Shift+J (Console)
      if (e.ctrlKey && e.shiftKey && e.key === 'J') { e.preventDefault(); return false; }
      // Ctrl+Shift+C (Element inspector)
      if (e.ctrlKey && e.shiftKey && e.key === 'C') { e.preventDefault(); return false; }
      // Ctrl+U (View source)
      if (e.ctrlKey && e.key === 'u') { e.preventDefault(); return false; }
      // Ctrl+S (Save page)
      if (e.ctrlKey && e.key === 's') { e.preventDefault(); return false; }
      // Cmd variants for Mac
      if (e.metaKey && e.altKey && e.key === 'i') { e.preventDefault(); return false; }
      if (e.metaKey && e.altKey && e.key === 'j') { e.preventDefault(); return false; }
      if (e.metaKey && e.key === 'u') { e.preventDefault(); return false; }
      if (e.metaKey && e.key === 's') { e.preventDefault(); return false; }
    };

    // --- Disable text selection via CSS ---
    const style = document.createElement('style');
    style.id = 'site-protection-styles';
    style.textContent = `
      body {
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }
      /* Allow selection in input fields and textareas */
      input, textarea, [contenteditable="true"], pre, code {
        -webkit-user-select: text !important;
        -moz-user-select: text !important;
        -ms-user-select: text !important;
        user-select: text !important;
      }
      /* Disable image dragging */
      img {
        -webkit-user-drag: none !important;
        user-drag: none !important;
        pointer-events: auto;
      }
    `;
    document.head.appendChild(style);

    // --- Disable drag on images ---
    const handleDragStart = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('dragstart', handleDragStart);

    // --- Console warning ---
    console.log(
      '%c⛔ STOP!',
      'color: red; font-size: 40px; font-weight: bold; text-shadow: 2px 2px 0 #000;'
    );
    console.log(
      '%cThis browser feature is intended for developers. If someone told you to copy-paste something here, it is a scam.',
      'font-size: 16px; color: #333;'
    );
    console.log(
      '%c© GOPIKO — All rights reserved. Unauthorised reproduction is prohibited under the Australian Copyright Act 1968.',
      'font-size: 12px; color: #666;'
    );

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('dragstart', handleDragStart);
      document.body.style.opacity = '';
      document.body.style.pointerEvents = '';
      const s = document.getElementById('site-protection-styles');
      if (s) s.remove();
    };
  }, []);

  // Invisible content fingerprint watermark
  return (
    <span
      aria-hidden="true"
      style={{ position: 'absolute', left: '-9999px', top: '-9999px', fontSize: 0, opacity: 0, pointerEvents: 'none' }}
      data-ownership="gopiko-au-2026"
      data-hash={btoa(`gopiko-${Date.now()}-${Math.random().toString(36).slice(2)}`)}
    >
      GOPIKO Pty Ltd — Intellectual Property Protected — Australian Copyright Act 1968
    </span>
  );
};

export default SiteProtection;
